import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faDoNotEnter } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { PrivacyCookiePolicyMenu } from "../../components/PrivacyCookiePolicyMenu";
import { CustomButton } from "../CustomButton";
import "./style.css";

const fm = getFormattedMessageWithScope("components.PaymentFailedSummary");

interface PaymentFailesSummaryProps {
    creditorName?: string;
    onGoToPaymentRequest: Function;
    paymentReason?: string;
    paymentError?: string;
}

export const PaymentFailedSummary = ({
    creditorName,
    onGoToPaymentRequest,
    paymentReason,
    paymentError,
}: PaymentFailesSummaryProps) => (
    <div className="c-PaymentFailedSummary">
        <div className="c-PaymentFailedSummary-header">
            <span className="c-PaymentFailedSummary-title">
                {fm("operationRefused")}
            </span>
            <p className="c-PaymentFailedSummary-subtitle">
                {fm("paymentFailed")}
            </p>
        </div>
        <div className="c-PaymentFailedSummary-content">
            <div className="c-PaymentFailedSummary-content-heading">
                <div className="c-PaymentFailedSummary-content-heading-firstLine">
                    <span className="c-PaymentFailedSummary-content-summary">
                        {fm("summary")}
                    </span>
                    <PrivacyCookiePolicyMenu />
                </div>
                <p className="c-PaymentFailedSummary-content-onBehalfOf">
                    {fm({
                        id: "onBehalfOf",
                        values: {
                            companyName: creditorName ? creditorName : "-",
                        },
                    })}
                </p>
            </div>
            <div className="c-PaymentFailedSummary-content-paymentData">
                <span className="c-PaymentFailedSummary-content-creditorName">
                    {creditorName ? creditorName : "-"}
                </span>
                <p className="c-PaymentFailedSummary-content-paymentReason-label">
                    {fm("paymentReason")}
                </p>
                <span className="c-PaymentFailedSummary-content-paymentReason-value">
                    {paymentReason || "-"}
                </span>
                <div className="c-PaymentFailedSummary-content-error-container">
                    <div>
                        <FontAwesomeIcon
                            icon={faDoNotEnter as IconProp}
                            className="c-PaymentFailedSummary-content-error-icon"
                        />
                    </div>
                    <div>
                        <p className="c-PaymentFailedSummary-content-error-label">
                            {fm("error")}
                        </p>
                        <span className="c-PaymentFailedSummary-content-error-message">
                            {paymentError}
                        </span>
                    </div>
                </div>
                <p className="c-PaymentFailedSummary-content-info-message">
                    {fm("goBackToRequestInfo")}
                </p>
                <div className="c-PaymentFailedSummary-content-buttons">
                    <CustomButton
                        kind="primary"
                        colorScheme="alert"
                        className="c-PaymentFailedSummary-content-buttons-button"
                        onClick={onGoToPaymentRequest}
                    >
                        {fm("goBackToPaymentRequest")}
                    </CustomButton>
                </div>
            </div>
        </div>
    </div>
);
